import { render } from "./ModeloCreate.vue?vue&type=template&id=534d0342&scoped=true"
import script from "./ModeloCreate.vue?vue&type=script&lang=js"
export * from "./ModeloCreate.vue?vue&type=script&lang=js"

import "./ModeloCreate.vue?vue&type=style&index=0&id=534d0342&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534d0342"]])

export default __exports__